import { mapGetters } from 'vuex'

export default {
  methods: {
    like(attractionId) {
      if (this.isLiked(attractionId)) {
        this.removeLike(attractionId)
      } else {
        if (this.containsGroup(attractionId)) {
          this.$store.commit('attractions/LIKE_GROUP', this.getGroup(attractionId))
        } else {
          this.$store.commit('attractions/LIKE_ATTRACTION', attractionId)
        }
      }
    },
    isLiked(attractionId) {
      return this.likedAttractionsIds.includes(attractionId)
    },
    containsGroup(attractionId) {
      const attraction = this.attractions.find(obj => obj._id === attractionId)
      if (attraction.parentAttraction) {
        return attraction.parentAttraction[0]
      }
      return this.attractions.find(obj => {
        if (obj.parentAttraction) {
          return obj.parentAttraction.find(parent => parent === attractionId)
        }
      })
    },
    getGroup(attractionId) {
      // const likedBy = this.$store.state.attractions.likedBy
      const likedAttractions = this.$store.state.attractions.likedAttractions
      const likedAttractionsObj = this.attractions.filter(a => likedAttractions.find(la => a._id === la))
      // const attraction = this.attractions.find(obj => obj._id === attractionId)

      // if (attraction.parentAttraction) {
      //   const isParentAtCalculator = !!attraction.parentAttraction.find(p => likedAttractions.includes(p))
      //   console.log(isParentAtCalculator,'isParentAtCalculator')
      //   if (
      //     likedAttractions.length &&
      //     !isParentAtCalculator &&
      //     attraction.parentAttraction[0] !== '5a2ffbdb142d58464cbac7e7'
      //   ) {
      //     const attrWithParent = this.attractions
      //     .find(a => a.parentAttraction && a.parentAttraction.length > 1).parentAttraction

      //     const inCalculatorParent = attrWithParent.find(p => p !== attraction.parentAttraction[0])
      //     const notInCalculatorParent = attrWithParent.find(p => p === attraction.parentAttraction[0])

      //     const attrWithParentInCalc = likedAttractionsObj.filter(a => {
      //       if (a.parentAttraction) {
      //         return a.parentAttraction.find(p => p === inCalculatorParent)
      //       }
      //     }).map(obj => obj._id)

      //     const attrWithParentNotInCalc = this.attractions.filter(a => {
      //       if (a.parentAttraction) {
      //         return a.parentAttraction.find(p => p === notInCalculatorParent)
      //       }
      //     }).map(obj => obj._id)

      //     attrWithParentInCalc.unshift(inCalculatorParent)
      //     attrWithParentNotInCalc.unshift(notInCalculatorParent)

      //     this.$store.commit('attractions/REMOVE_GROUP', attrWithParentInCalc)
      //     this.$store.commit('attractions/SET_LIKED_BY', notInCalculatorParent)

      //     return attrWithParentNotInCalc
      //   }
      //   const firstParent = attraction.parentAttraction[0]
      //   const secondParent = attraction.parentAttraction[1]

      //   const group = this.attractions.filter(obj => {
      //     if (obj.parentAttraction && attraction.parentAttraction.length > 1) {
      //       if (likedBy) {
      //         return attraction.parentAttraction.find(parent => parent === obj.parentAttraction[0])
      //       }
      //       return obj.parentAttraction[0] === firstParent
      //     } else if (obj.parentAttraction && attraction.parentAttraction.length === 1) {
      //       this.$store.commit('attractions/SET_LIKED_BY', firstParent)
      //       return obj.parentAttraction.find(parent => parent === firstParent)
      //     }
      //   }).map(obj => {
      //     return obj._id
      //   })

      //   likedBy && attraction.parentAttraction.length > 1 ? group.unshift(firstParent, secondParent)
      //   : group.unshift(firstParent)

      //   return group
      // } else {
        this.$store.commit('attractions/SET_LIKED_BY', attractionId)
        const isCalcHasParent = likedAttractionsObj && likedAttractionsObj
        .find(liked => liked.parentAttraction)

        if (isCalcHasParent && attractionId !== '5a2ffbdb142d58464cbac7e7') {
          const attrWithParent = likedAttractionsObj
          .find(a => a.parentAttraction && a.parentAttraction.length >= 1).parentAttraction

          const inCalculatorParent = attrWithParent.find(p => p !== attractionId)
          const isCalcHasAnotherParent = likedAttractions.find(liked => liked === inCalculatorParent)

          if (isCalcHasAnotherParent) {
            const attrWithParentInCalc = likedAttractionsObj.filter(attraction => {
              if (attraction.parentAttraction) {
                return attraction.parentAttraction
              }
            }).map(obj => obj._id)

            const attrWithParentNotInCalc = this.attractions.filter(a => {
              if (a.parentAttraction) {
                return a.parentAttraction.find(parent => parent === attractionId)
              }
            }).map(obj => obj._id)

            attrWithParentInCalc.unshift(inCalculatorParent)
            attrWithParentNotInCalc.unshift(attractionId)
            // this.$store.commit('attractions/REMOVE_GROUP', attrWithParentInCalc)
            this.$store.commit('attractions/SET_LIKED_BY', attractionId)

            return attrWithParentNotInCalc
          }
        }

        const group = this.attractions.filter(obj => {
          if (obj.parentAttraction) {
            return obj.parentAttraction.find(parent => parent === attractionId)
          }
        }).map(obj => {
          return obj._id
        })
        group.unshift(attractionId)
        return attractionId
      // }
    },
    removeLike(attractionId) {
      if (this.containsGroup(attractionId)) {
        this.$store.commit('attractions/REMOVE_GROUP', this.getGroup(attractionId))
      } else {
        this.$store.commit('attractions/REMOVE_LIKE', attractionId)
      }
    }
  },
  computed: {
    ...mapGetters('attractions', [
      'likedAttractionsIds',
      'attractions'
    ]),
  }
}
